import React__default from 'react';
import { Tag } from '@grandvisionhq/common';
import { useProductData } from '../../../../context/product-context-hooks.js';

const ProductTag = ({ className  })=>{
    const { activeVariant: { productTag  } ,  } = useProductData();
    if (!productTag || productTag.value === '') {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(Tag, {
        className: className,
        iconKey: productTag.iconKey,
        label: productTag.value
    });
};

export { ProductTag };
//# sourceMappingURL=ProductTag.js.map
